<template>
  <div class="container application">
    <div class="term-desc" />
    <h2 class="mt-2">추가 운전자 등록이 완료 되었습니다.</h2>

    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full btn_outline"
          @click.prevent="complete"
        >
          계약 정보 보러가기
        </button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import config from 'config';
import { closeWebView } from 'utils/webview/closeWebView';
import { isWebview } from 'utils/webview/isWebview';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';

export default {
  name: 'Step03',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rentalHistoryUrl: config.rentalHistory.baseURL,
      application: this.data,
    };
  },
  created() {
    const { contractId, fellowDrivers } = this.data;
    this.$gtag.event('view', {
      page_name: 'plan_contract_extra_driver_3_complete',
      event_category: document.title,
      page_url: document.URL,
      component_type: fellowDrivers.length || 0,
      reservation_id: contractId,
    });
  },
  methods: {
    complete() {
      if (isWebview()) {
        postMessageToPlanHome('/mypage');
        closeWebView();
        return;
      }
      window.location.href = this.rentalHistoryUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.application {
  min-height: 300px;
}
</style>
